export default __webpack_public_path__ + "static/media/icon_star_idle.3ed1b36a.svg";